import { jsx as _jsx } from "react/jsx-runtime";
import MuiCircularProgress from '@mui/material/CircularProgress';
import colors from '../../colors';
var Spinner = function (_a) {
    var _b = _a.color, color = _b === void 0 ? colors.white : _b, _c = _a.size, size = _c === void 0 ? '12px' : _c;
    return (_jsx(MuiCircularProgress, { thickness: 6, size: size, sx: {
            color: color,
            margin: '4px',
        } }));
};
export default Spinner;
